import { render, staticRenderFns } from "./CompagnyView.vue?vue&type=template&id=f15851aa&"
import script from "./CompagnyView.vue?vue&type=script&lang=js&"
export * from "./CompagnyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports